import store from "@/store"

class Hls {
  constructor() {
    this.multicast = false
    this.init = false
    this.player = null
    this.timeout = null
  }
  async _init() {
    if (this.init) return true

    _$.vue.$on("mediaEnded", async () => {
      if (!__.media.getLoop()) return false
      if (__.platform.hasBackground()) __.platform.background(store.state.background.slides, __.media.getSource())
      else __.media.play(__.media.getSource(), true)
    })

    _$.loader.createPlayer("object", {
      id: "videoMp4",
      type: "video/mp4",
      style: "position: absolute; left:0; top:0; right:0; bottom:0; width:100%; height:100%;"
    })

    this.player = document.getElementById("videoMp4")

    this.player.addEventListener("PlayStateChange", event => this._playerListener(event))
    this.init = true
    return true
  }

  async start() {
    if (document.getElementById("videoBroadcast")) document.getElementById("videoBroadcast").style.display = "none"
    document.getElementById("videoMp4").style.display = null

    __.common._tvWindowSetSize()
    await _$.sleep(1000)
    return true
  }
  async destroy() {
    this.stop()
    document.getElementById("videoMp4").style.display = "none"

    return true
  }
  async play(source) {
    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    _$.vue.$once(["mediaPlaying", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    this.player.data = ""
    this.player.data = source

    this.player.play(1)

    return promise.done
  }
  async stop() {
    const promise = await _$.progress.create()

    _$.vue.$once(["mediaStopped", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    this.player.stop()

    return promise.done
  }
  async pause() {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPaused", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    this.player.play(0)

    return promise.done
  }
  async continue() {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPlaying", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    this.player.play(1)

    return promise.done
  }

  /* Control Helpers */
  async isSeekable() {
    return this.player.playTime
  }
  async getDuration() {
    return Math.round(this.player.playTime / 1000)
  }
  async getPosition() {
    return Math.round(this.player.playPosition / 1000)
  }
  async setPosition(position) {
    return this.player.seek(position * 1000)
  }

  /* Language and Subtitles Helpers */
  async getSubtitles() {
    const type = this.player.COMPONENT_TYPE_SUBTITLE
    let subtitles = this.player.getComponents(type)

    if (!subtitles.length) return false
    subtitles = Array.from(subtitles)
    subtitles = subtitles.map(audio => {
      return { key: audio.pid, value: audio.language, selected: false }
    })

    if (subtitles.length <= 1) return false
    return subtitles
  }
  async setSubtitle(pid) {
    const type = this.player.COMPONENT_TYPE_SUBTITLE
    let subtitles = this.player.getComponents(type)
    if (!subtitles.length) return false

    subtitles = Array.from(subtitles)

    const component = subtitles.find(rec => rec.pid == pid)
    if (!component) return false

    this.player.selectComponent(component)

    return true
  }
  async closeSubtitle() {
    return this.player.selectComponent(0)
  }

  async getLanguages() {
    const type = this.player.COMPONENT_TYPE_AUDIO
    let audios = this.player.getComponents(type)

    if (!audios.length) return false
    audios = Array.from(audios)
    audios = audios.map(audio => {
      return { key: audio.pid, value: audio.language, selected: false }
    })

    if (audios.length <= 1) return false
    return audios
  }
  async setLanguage(pid) {
    const type = this.player.COMPONENT_TYPE_AUDIO
    let audios = this.player.getComponents(type)
    if (!audios.length) return false

    audios = Array.from(audios)

    const component = audios.find(rec => rec.pid == pid)
    if (!component) return false

    this.player.selectComponent(component)

    return true
  }

  async _playerListener(event) {
    let state = null
    if (__.device.properties.product === "MB100") {
      switch (this.player.playState) {
        case 0:
          state = "stop"
          break
        case 1:
          state = "play"
          break
        case 2:
          state = "pause"
          break
        case 3:
          state = "start"
          break
        case 4:
          state = "buffer"
          break
        case 5:
          state = "ended"
          break
        default:
          state = "error"
          break
      }
    } else {
      switch (event.state) {
        case 0:
          state = "stop"
          break
        case 1:
          state = "play"
          break
        case 2:
          state = "pause"
          break
        case 3:
          state = "start"
          break
        case 4:
          state = "buffer"
          break
        case 5:
          state = "ended"
          break
        default:
          state = "error"
          break
      }
    }
    if (!state) return false
    if (this.timeout) this.timeout = window.clearTimeout(this.timeout)
    this.timeout = window.setTimeout(() => _$.handler.emit("media_event", state), 1000)

    return true
  }
}

export default Hls
